import slider_icon1 from '../images/mirea/slider_icon1.svg'
import slider_icon2 from '../images/mirea/slider_icon2.svg'
import slider_icon3 from '../images/mirea/slider_icon3.svg'
import slider_icon4 from '../images/mirea/slider_icon4.svg'
import slider_icon5 from '../images/mirea/slider_icon5.svg'

export const mireaSlider = [
  {
    id: 1,
    title: 'Качественное образование',
    img: slider_icon1,
    text: 'Расширенная учебная программа, включающая курсы по разработке биофармацевтических процессов от практикующих экспертов'
  },
  {
    id: 2,
    title: 'Работа с наставником',
    img: slider_icon2,
    text: 'Выполнение квалификационной магистерской работы под руководством ведущих специалистов компании'
  },
  {
    id: 3,
    title: 'Реальные проекты',
    img: slider_icon3,
    text: 'Написание выпускной квалификационной работы по актуальным проектам компании'
  },
  {
    id: 4,
    title: 'Современное оборудование',
    img: slider_icon4,
    text: 'Обучение и работа на современном, высокотехнологичном лабораторном оборудовании прямо в стенах университета'
  },
  {
    id: 5,
    title: 'Старт карьеры',
    img: slider_icon5,
    text: 'Гарантированное трудоустройство по завершении образовательной программы'
  }
]
